import { type JSX } from "react";
export const EmptyDataIcon = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="63"
      viewBox="0 0 65 63"
      fill="none">
      <path
        d="M12.75 26.6158V24.75C12.75 22.1094 14.8906 19.9688 17.5312 19.9688H33.4688C36.1094 19.9688 38.25 22.1094 38.25 24.75V26.6158M12.75 26.6158C13.2485 26.4396 13.7849 26.3438 14.3438 26.3438H36.6562C37.2151 26.3438 37.7515 26.4396 38.25 26.6158M12.75 26.6158C10.893 27.2722 9.5625 29.0432 9.5625 31.125V32.9908M38.25 26.6158C40.107 27.2722 41.4375 29.0432 41.4375 31.125V32.9908M41.4375 32.9908C40.939 32.8146 40.4026 32.7188 39.8438 32.7188H11.1562C10.5974 32.7188 10.061 32.8146 9.5625 32.9908M41.4375 32.9908C43.2945 33.6472 44.625 35.4182 44.625 37.5V50.25C44.625 52.8906 42.4844 55.0312 39.8438 55.0312H11.1562C8.51564 55.0312 6.375 52.8906 6.375 50.25V37.5C6.375 35.4182 7.70547 33.6472 9.5625 32.9908"
        stroke="#4F46E5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.25 22.5L48.75 3.75L45 17.5H58.75L41.25 36.25L45 22.5H31.25Z"
        stroke="#FFD44A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SaveIcon = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-save">
      <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" />
      <path d="M7 3v4a1 1 0 0 0 1 1h7" />
    </svg>
  );
};

export const BrainIcon = (): JSX.Element => {
  return (
    <svg
      className="w-6 h-6 text-purple-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
      />
    </svg>
  );
};
